import { Rule } from '../rule'
import { uuid } from '../uuid'
import { DependOnOption, DisabledType } from '../common'

export class NumberDef {
  key?: string = uuid()
  type: 'number' = 'number'
  model!: string
  label!: string
  dependOn?: DependOnOption
  options?: NumberOptions = new NumberOptions()
  rules?: Rule[]
}

export class NumberOptions {
  defaultValue?: number
  disabled?: DisabledType = false
  placeholder?: string
  max?: number
  min?: number
  unit?: boolean = true
  precision?: number
  labelWidth?: string | number
  required?: boolean = false
  prepend?: string
  append?: string
  showLabel?: boolean = true
  showActual?: boolean = false
}
